import { render, staticRenderFns } from "./HeaderChangePasswordDialog.vue?vue&type=template&id=b5b5c774"
import script from "./HeaderChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./HeaderChangePasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports